import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';

@Injectable({
    providedIn: 'root',
})
export class RtCommodityShippedGridService {
    private readonly baseUrl: string;
    private readonly odataUrl: string;

    constructor(
        private http: HttpClient,
        private fb: UntypedFormBuilder,
        @Inject('BASE_API_URL') private apibaseUrl: string,
        @Inject('BASE_ODATA_URL') private odatabaseUrl: string,
    ) {
        this.baseUrl = this.apibaseUrl;
        this.odataUrl = this.odatabaseUrl;
    }

    getODataStore(): DataSource {
        return new DataSource({
            store: new ODataStore({
                version: 4,
                url: this.odataUrl + 'CommodityShippedGrid',
            }),
            paginate: true,
            pageSize: 20,
        });
    }
}
